export class DropdownWithRulesInput {
  channel: string;
  dropdownWithRulesFlag: boolean;

  constructor(channel: string, dropdownWithRulesFlag: boolean) {
    this.channel = channel;
    this.dropdownWithRulesFlag = dropdownWithRulesFlag;
  }
}
